<template>
  <v-card>
    <v-toolbar flat color="primary">
      <v-toolbar-title class="body-2">
        <span class="headline">RFE</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="card-container">
      <span class="subheading">Request File</span>
      <v-container class="rfe-container">
        <v-checkbox label="Bank Statement" value="Bank Statement" v-model="isCheckRfe" hide-details></v-checkbox>
        <v-text-field v-if="isShowRfeText" prepend-icon="arrow_forward" v-model="rfeNote" hide-details></v-text-field>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="saveRfeNote">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { OriginationBusinessApi } from '@/api/pandaria'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'rfe-dialog',
  props: {
    loan: Object
  },
  data () {
    return {
      isCheckRfe: '',
      rfeNote: '',
      isShowRfeText: false
    }
  },
  watch: {
    isCheckRfe: function (newVal) {
      this.isShowRfeText = tool.isNotEmpty(newVal)
    }
  },
  methods: {
    hideDialog () {
      this.isCheckRfe = ''
      this.rfeNote = ''
      this.$emit('hideDialog', 'RFE')
    },
    saveRfeNote () {
      if (tool.isEmpty(this.rfeNote)) {
        popup.popupForWarning('Please enter content')
      } else {
        const $this = this
        const status = DataType.LoanStatus.CUSTOMER_REVIEW.value
        const request = {
          loanId: $this.loan.id,
          status: status
        }
        OriginationBusinessApi.changeLoanStatus(request, function () {
          $this.$eventBus.$emit('updateStatus', { status })
          $this.$eventBus.$emit('forceUnlock', { unlockReason: DataType.UnlockLoanReasonEnum.STATUS_CHANGED.value })
          popup.popupForSuccess()
        },
        function (result) {
          popup.popupForWarning(result.message)
        }
        )
        this.hideDialog()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  margin-top: 20px !important;
  .subheading {
    font-size: 16px;
    font-weight: 600;
  }
  .rfe-container {
    padding-bottom: 0;
    padding-top: 0;
    min-height: 80px;
  }
}
</style>
